import React from 'react'

function ServicePageBg({data}) {
  return (
    <> 
    <section className="service-page-bg" style={{ backgroundImage: `url(${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL+data?.banner_image})` }}>
      
    </section>
    </>
  )
}
export default ServicePageBg